/**
 * Shared store accounts type WHO is writing (comment author, "completed
 * by"). Owner ruling 2026-10-22 (round 2: the composer started with the
 * account's own name, so comments posted as "[SIM] Store User" — no person):
 * the name is required and can't be the account itself. Pure — shared by
 * the app (task page, Complete dialog) and the server (api/src/writePolicy.ts).
 */

export const NAME_REQUIRED_MESSAGE =
  'Type your own name — store accounts are shared, so the name records who actually did this.';

const fold = (s: string) => s.normalize('NFKC').replace(/\s+/gu, ' ').trim().toLowerCase();

/** A person's name: not blank, and not the signed-in account's own name or address. */
export function isPersonName(typed: string, account: { displayName: string; upn: string }): boolean {
  const t = fold(typed);
  return t !== '' && t !== fold(account.displayName) && t !== fold(account.upn);
}
